import styled, { css } from "styled-components"

export const ButtonStyle = styled.button`
  justify-content: center;
  text-transform: uppercase;
  border-radius: 5px;
  font-family: Roboto;
  font-weight: 600;
  align-items: center;
  text-align: center;
  font-size: 14px;
  padding: 0 20px;
  display: flex;
  cursor: pointer;
  border: none;
  height: 40px;
  width: ${({ width }) => width || "max-content"};
  margin: ${({ margin }) => margin || ""};

  i {
    margin: ${({ marginIcon }) => marginIcon || "0 20px 0 0"};
  }

  ${({ primaryColor, type, disabled }) => {
    const commonStyles = css`
      transition: 250ms ease-out;
      border: 1px solid ${primaryColor};
    `

    switch (type) {
      case "primary":
        return css`
          ${commonStyles}
          background-color: ${primaryColor};
          color: #fff;

          &:hover {
            background-color: ${primaryColor + "3F"};
            color: ${primaryColor};
          }

          ${disabled &&
          css`
            background-color: ${primaryColor + "3F"};
            border: 1px solid ${primaryColor + "3F"};
            cursor: not-allowed;
            &:hover {
              color: #fff;
            }
          `}
        `
      case "secondary":
        return css`
          ${commonStyles}
          background-color: #fff;
          color: ${primaryColor};

          &:hover {
            background-color: ${primaryColor + "3F"};
          }

          ${disabled &&
          css`
            color: ${primaryColor + "3F"};
            border: 1px solid ${primaryColor + "3F"};
            cursor: not-allowed;
            &:hover {
              color: ${primaryColor + "3F"};
              background-color: #fff;
            }
          `}
        `
      default:
        return ""
    }
  }}

  ${({ expendOnHover }) =>
    expendOnHover &&
    css`
      transition: 250ms ease-out;
      width: fit-content;

      i {
        margin: 0;
      }
      p {
        transition: 250ms ease-out;
        display: none;
      }

      &:hover {
        width: max-content;

        i {
          margin: 0 20px 0 0;
        }
        p {
          display: block;
        }
      }
    `}
`
